/** 本文件由工具自动生成,请勿手动修改！ **/
// @ts-nocheck
import { useState,  useEffect } from 'react';
import * as R from 'ramda';
import Request, { YWRequestConfig } from '@ywfe/request';
import { getHost, reduceParams, parseParams, querystring } from '@ywfe/utils';

  
    const { basePath = '', loginPath = '' } = getHost("PRO_SETTLE", "542")
  

// 接口文档

  
    
export interface IAPI76710ResDataItem {
  
  /** 推荐文案 */
  recommendDocument?: string;
  
  /** 引导文案 */
  guideDocument?: string;
  
};
    
  



export type API76710Req = {};



export type API76710Res = IAPI76710ResDataItem[];


// 接口函数 76710 查询任务助手文案

export interface IUseGetAPI76710Return {
  /** 查询任务助手文案: 接口请求状态 */
  isAPI76710Loading: boolean;
  /** 查询任务助手文案: 接口请求返回数据 */
  dataAPI76710: API76710Res;
  /**  查询任务助手文案: 接口数据请求方法 */
  fetchAPI76710Data: ( config?: YWRequestConfig) => Promise<API76710Res>;
  /** 查询任务助手文案: 接口请求URL */
  requestUrl: string;
}

export const useGetAPI76710 = ():IUseGetAPI76710Return => {
  let isMount = true;
  const [isAPI76710Loading, setIsAPI76710Loading] = useState(false);
  const [dataAPI76710, setDataAPI76710] = useState<API76710Res>({} as API76710Res);
  const requestUrl = `${basePath}/yoaichat-web/task/instance/query/document`;

  const fetchAPI76710Data = async ( config?: YWRequestConfig): Promise<API76710Res> => {
  
    if ( isMount ) {
      setIsAPI76710Loading(true);
    }

    try {
      
      
      const res: any = await Request.get<API76710Res>(`${basePath}/yoaichat-web/task/instance/query/document`, {
        loginHost: loginPath,
        ...config
      });
      
      
      
      if (isMount) {
        setDataAPI76710(res || {} as API76710Res);
        setIsAPI76710Loading(false);
      }
      return res;
    } catch (error) {
      console.error('[ERROR] API Request Error: ', error);
      if ( isMount ) {
        setIsAPI76710Loading(false);
      }
      return false as unknown as API76710Res;
    }
  }

  useEffect(() => {
    return () => {
      isMount = false;
    };
  }, []);

  return {
    isAPI76710Loading,
    dataAPI76710,
    fetchAPI76710Data,
    requestUrl,
  }
}

